import { BorderOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import Modal from 'antd/lib/modal/Modal';
import { autobind } from 'core-decorators';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import { TableController } from '../../controls/TableController';
import { admin_fetchPlaces } from '../../lib/api-web';
import modals from '../../stores/modals';
import { Sorting } from '../../web-types/Sorting';

export interface SelectPlaceModalProps {
	chainId: number | null;
	notInChainId: number | null;
	defaultPlaceId?: number | null;
	onDismiss: () => void;
	onConfirm: (placeId: number) => void;
}

@observer
export default class SelectPlaceModal extends PureComponent<SelectPlaceModalProps> {
	static async show(
		chainId: number | null,
		notInChainId: number | null,
		defaultPlaceId?: number | null,
	): Promise<number | null> {
		return new Promise<number | null>(resolve => {
			modals.show((close: () => void) => (
				<SelectPlaceModal
					chainId={chainId}
					notInChainId={notInChainId}
					defaultPlaceId={defaultPlaceId}
					onDismiss={() => {
						close();
						resolve(null);
					}}
					onConfirm={placeId => {
						close();
						resolve(placeId);
					}}
				/>
			));
		});
	}

	@observable contentVisible = false;
	@observable total: number | null = null;
	@observable params: { query: string } = { query: '' };
	@observable selected: number | null = this.props.defaultPlaceId || null;

	@autobind
	handleTablePropsUpdate(contentVisible: boolean, total: number | null, rowsPerPage: number) {
		this.contentVisible = contentVisible;
		this.total = total;
	}

	@autobind
	async handleLoad(params: { query: string }, offset: number, limit: number, sorting: Sorting | null) {
		return admin_fetchPlaces(offset, limit, {
			query: params.query,
			sorting: sorting || null,
			chainId: this.props.chainId || null,
			notInChainId: this.props.notInChainId || null,
		});
	}

	render() {
		return (
			<Modal
				title="Select place"
				onCancel={() => this.props.onDismiss()}
				visible={true}
				closable={false}
				okButtonProps={{
					disabled: !this.selected,
				}}
				onOk={() => {
					this.props.onConfirm(this.selected!);
				}}
			>
				<Input.Search
					style={{ marginBottom: 15 }}
					type="search"
					onSearch={value => (this.params.query = value)}
					placeholder="Search place..."
				/>
				<TableController
					onRowClick={({ id }) => {
						this.selected = id;
					}}
					noSection
					params={this.params}
					load={this.handleLoad}
					onTablePropsUpdate={this.handleTablePropsUpdate}
					rowClass={({ id }) => (this.selected === id ? 'row-selected' : 'dummy-class')}
					columns={[
						{
							key: 'logoUrl',
							title: '',
							render: value => <Avatar size={30} src={value} icon={<BorderOutlined />} />,
							width: 50,
						},
						{
							key: 'name',
							title: 'Name',
							sortable: true,
							render: (value, row) => `${row.name}`,
						},
						{
							key: 'chain.name',
							title: 'Chain',
							sortable: true,
						},
					]}
				/>
			</Modal>
		);
	}
}
